import _ from 'lodash';
import {apiFetch, apiSearch} from '../utility';

const apiBase = 'stationInvoice';

const STATION_INVOICE_RESULT = 'accounting/stationInvoice/SEARCH/';
const STATION_INVOICE_STATUS_CHANGE = 'accounting/stationInvoice/CHANGE';

const initialState = {
	byStationId : {},
	byStatus : {},
};

export default (state = initialState, action) => {

	if (action.type === STATION_INVOICE_RESULT) {
		if (action.stationId) {
			return {
				...state,
				byStationId: {
					...state.byStationId,
					[action.stationId]: _.map(action.stationInvoices, 'stationInvoiceIds'),
				}
			};
		} else if (action.status) {
			return {
				...state,
				byStatus: {
					...state.byStatus,
					[action.status]: _.map(action.stationInvoices, 'stationInvoiceId'),
				}
			};
		} else {
			return state;
		}
	} else if (action.type === STATION_INVOICE_STATUS_CHANGE) {
		const {status, stationInvoiceId} = action.stationInvoice;

		const pendingIds = _.get(state, ['byStatus', 'pending']);
		const invalidIds = _.get(state, ['byStatus', 'invalid']);
		const issuedIds = _.get(state, ['byStatus', 'issued']);
		if (!pendingIds || !issuedIds) {
			return state;
		}

		//- New pending invoice. Means we have a new invoice
		if (status === 'pending') {
			const newPendingIds = _.uniq(pendingIds.concat([stationInvoiceId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
				}
			};
		}


		//- New invalid invoice. Means we have a new invoice
		if (status === 'invalid') {
			const newInvalidIds = _.uniq(invalidIds.concat([stationInvoiceId]));
			const newPendingIds = _.filter(pendingIds, id => {
				return id !== stationInvoiceId;
			});
			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					invalid: newInvalidIds,
				}
			};
		}

		if (status === 'issued') {
			const newIssuedIds = _.uniq(issuedIds.concat([stationInvoiceId]));
			const newPendingIds = _.filter(pendingIds, id => {
				return id !== stationInvoiceId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					issued: newIssuedIds,
				}
			};
		}
	} else {
		return state;
	}
};

export const search = (p) => {
	const {
		status,
		stationId,
		afterDate,
		callback = _.noop,
	} = p;

	return dispatch => {
		const params = {
			status,
			afterDate,
			stationId
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }

				const stationInvoices = _.get(r, ['collections', 'stationInvoiceCollection']);
				dispatch({
					type: STATION_INVOICE_RESULT,
					status,
					stationId,
					stationInvoices,
				});
				callback();
			}
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getEmailInfo = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getEmailInfo`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'bulkDeliveryIds',
			params,
			dispatch,
			callback,
			successMessage : `Station invoice created successfully. 
				Click continue to return to the station invoices page.`,
			onSuccessRedirectTo : `/accounting/stationInvoices`,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const invalidate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				dispatch({
					type: STATION_INVOICE_STATUS_CHANGE,
					stationInvoice,
				});
				callback();
			}

		});
	};
};

export const send = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.send`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				dispatch({
					type: STATION_INVOICE_STATUS_CHANGE,
					stationInvoice,
				});
				callback();
			}
		});
	};
};

export const searchLogs = ({stationInvoiceId, callback = _.noop}) => {
	return dispatch => {
		apiSearch({
			method : 'stationInvoice.log.search',
			base : 'stationInvoiceLog',
			keyBy : stationInvoiceId,
			params : {
				stationInvoiceId,
			},
			dispatch,
			callback,
		});
	};
};


export const advancedSearch = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method : 'stationInvoice.advancedSearch',
			params,
			dispatch,
			callback
		});
	};
};

export const getProductInvoiceMatrix = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method : 'stationInvoice.getProductInvoiceMatrix',
			params,
			dispatch,
			callback
		});
	};
};
